import { Authenticated } from './middleware'

export default [{
  name: 'cpanel.dashboard',
  path: 'dashboard',
  component: () => import('@/views/cpanel/Dashboard'),
  meta: {
    title: 'Админ - панель',
    back: false,
    middleware: [Authenticated]
  }
},
{
  name: 'cpanel.profile',
  path: 'profile',
  component: () => import('@/views/cpanel/Profile'),
  meta: {
    title: 'Мой профиль',
    back: 'cpanel.dashboard',
    middleware: Authenticated
  }
},
{
  name: 'cpanel.questionnaire',
  path: 'questionnaire',
  component: () => import('@/layouts/index'),
  redirect: { name: 'cpanel.questionnaire.list' },
  meta: {
    title: 'Список анкет',
    back: 'cpanel.dashboard',
    middleware: Authenticated
  },
  children: [
    {
      name: 'cpanel.questionnaire.list',
      path: 'list',
      component: () => import('@/views/cpanel/questionnaire/List'),
      meta: {
        title: 'Анкета',
        back: 'cpanel.dashboard',
        middleware: Authenticated,
        permission: 'can.manage.users'
      }
    }, {
      name: 'cpanel.questionnaire.item',
      path: ':id?',
      component: () => import('@/views/cpanel/questionnaire/Item'),
      meta: {
        title: 'Анкета',
        back: 'cpanel.questionnaire',
        middleware: Authenticated
      }
    },
    {
      name: 'cpanel.questionnaire.new',
      path: 'new',
      component: () => import('@/views/cpanel/questionnaire/New'),
      meta: {
        title: 'Новая анкета',
        back: 'cpanel.questionnaire',
        middleware: Authenticated,
        permission: 'can.manage.users'
      }
    }
  ]
},
{
  name: 'cpanel.push',
  path: 'push',
  component: () => import('@/layouts/index'),
  redirect: { name: 'cpanel.push.log' },
  meta: {
    title: 'Лог Пушей',
    back: 'cpanel.dashboard',
    middleware: Authenticated
  },
  children: [
    {
      name: 'cpanel.push.log',
      path: 'log',
      component: () => import('@/views/cpanel/push/Log'),
      meta: {
        title: 'Лог пушей',
        back: 'cpanel.dashboard',
        middleware: Authenticated,
        permission: 'can.manage.users'
      }
    },
    {
      name: 'cpanel.push.schedule',
      path: 'schedule',
      component: () => import('@/views/cpanel/push/Schedule'),
      meta: {
        title: 'Рассписание пушей',
        back: 'cpanel.dashboard',
        middleware: Authenticated,
        permission: 'can.manage.users'
      }
    }
  ]
},
{
  name: 'cpanel.workers',
  path: 'workers',
  component: () => import('@/layouts/alive'),
  redirect: { name: 'cpanel.worker.list' },
  meta: {
    title: 'Список Работников',
    back: 'cpanel.dashboard',
    middleware: Authenticated
  },
  children: [
    {
      name: 'cpanel.worker.list',
      path: 'list',
      component: () => import('@/views/cpanel/worker/List'),
      meta: {
        title: 'Сотрудники',
        back: 'cpanel.dashboard',
        middleware: Authenticated,
        permission: 'can.manage.users'
      }
    },
    {
      name: 'cpanel.worker.item',
      path: ':id?',
      component: () => import('@/views/cpanel/worker/Item'),
      meta: {
        title: 'Сотрудник',
        back: 'cpanel.worker.list',
        middleware: Authenticated,
        permission: 'can.manage.users'
      }
    }
  ]
},
{
  name: 'cpanel.users',
  path: 'users',
  component: () => import('@/layouts/index'),
  redirect: { name: 'cpanel.users.list' },
  meta: {
    title: 'Список пациентов',
    back: 'cpanel.dashboard',
    middleware: Authenticated
  },
  children: [
    {
      name: 'cpanel.users.list',
      path: 'list',
      component: () => import('@/views/cpanel/users/List'),
      meta: {
        title: 'Клиенты',
        back: 'cpanel.dashboard',
        middleware: Authenticated,
        permission: 'can.manage.users'
      }
    },
    {
      name: 'cpanel.users.id',
      path: ':id?',
      component: () => import('@/views/cpanel/users/List'),
      meta: {
        title: 'Клиент',
        back: 'cpanel.departments',
        middleware: Authenticated,
        permission: 'can.manage.users'
      }
    }
  ]
},
{
  name: 'cpanel.departments',
  path: 'departments',
  component: () => import('@/layouts/index'),
  redirect: { name: 'cpanel.departments.list' },
  meta: {
    title: 'Офисы',
    back: 'cpanel.dashboard',
    middleware: Authenticated
  },
  children: [
    {
      name: 'cpanel.departments.list',
      path: 'list',
      component: () => import('@/views/cpanel/department/List'),
      meta: {
        title: 'Офисы',
        back: 'cpanel.dashboard',
        middleware: Authenticated
      }
    },
    {
      name: 'cpanel.departments.item',
      path: ':id?',
      component: () => import('@/views/cpanel/department/Item'),
      meta: {
        title: 'Офис',
        back: 'cpanel.departments',
        middleware: Authenticated
      }
    }
  ]
},
{
  name: 'cpanel.tipDay',
  path: 'tipDay',
  component: () => import('@/layouts/index'),
  redirect: { name: 'cpanel.tipDay.list' },
  meta: {
    title: 'Совет дня',
    middleware: Authenticated
  },
  children: [
    {
      name: 'cpanel.tipDay.list',
      path: 'history',
      component: () => import('@/views/cpanel/tipDay/History'),
      meta: {
        title: 'Список советов дня',
        middleware: Authenticated
      }
    },
    {
      name: 'cpanel.tipDay.item',
      path: 'item/:id?',
      component: () => import('@/views/cpanel/tipDay/Item'),
      meta: {
        title: 'Информация о совете дня',
        back: 'cpanel.tipDay.list',
        middleware: Authenticated
      }
    },
    {
      name: 'cpanel.tipDay.new',
      path: 'new',
      component: () => import('@/views/cpanel/tipDay/New'),
      meta: {
        title: 'Совет дня',
        back: 'cpanel.tipDay.list',
        middleware: Authenticated
      }
    },
    {
      name: 'cpanel.tipDay.edit',
      path: 'edit/:id?',
      component: () => import('@/views/cpanel/tipDay/New'),
      props: true,
      meta: {
        title: 'Редактирование tipDay-уведомления',
        back: 'cpanel.tipDay.list',
        middleware: Authenticated
      }
    }
  ]
},
{
  name: 'cpanel.news',
  path: 'news',
  component: () => import('@/layouts/index'),
  redirect: { name: 'cpanel.news.list' },
  meta: {
    title: 'Новости',
    middleware: Authenticated
  },
  children: [
    {
      name: 'cpanel.news.list',
      path: 'history',
      component: () => import('@/views/cpanel/news/History'),
      meta: {
        title: 'Список новостей',
        middleware: Authenticated
      }
    },
    {
      name: 'cpanel.news.item',
      path: 'item/:id?',
      component: () => import('@/views/cpanel/news/Item'),
      meta: {
        title: 'Информация о новости',
        back: 'cpanel.tipDay.list',
        middleware: Authenticated
      }
    },
    {
      name: 'cpanel.news.new',
      path: 'new',
      component: () => import('@/views/cpanel/news/New'),
      meta: {
        title: 'Новость',
        back: 'cpanel.news.list',
        middleware: Authenticated
      }
    },
    {
      name: 'cpanel.news.edit',
      path: 'edit/:id?',
      component: () => import('@/views/cpanel/news/New'),
      props: true,
      meta: {
        title: 'Редактирование новости',
        back: 'cpanel.tipDay.list',
        middleware: Authenticated
      }
    }
  ]
},
{
  name: 'cpanel.push',
  path: 'push',
  component: () => import('@/layouts/index'),
  redirect: { name: 'cpanel.departments.list' },
  meta: {
    title: 'История push - уведомления',
    middleware: Authenticated
  },
  children: [
    {
      name: 'cpanel.push.list',
      path: 'history',
      component: () => import('@/views/cpanel/push/History'),
      meta: {
        title: 'push-уведомления',
        middleware: Authenticated
      }
    },
    {
      name: 'cpanel.push.item',
      path: 'item/:id?',
      component: () => import('@/views/cpanel/push/Item'),
      meta: {
        title: 'Информация о push - уведомления',
        back: 'cpanel.push.list',
        middleware: Authenticated
      }
    },
    {
      name: 'cpanel.push.new',
      path: 'new',
      component: () => import('@/views/cpanel/push/New'),
      meta: {
        title: 'Настройка push-уведомления',
        back: 'cpanel.push.list',
        middleware: Authenticated
      }
    },
    {
      name: 'cpanel.push.edit',
      path: 'edit/:id?',
      component: () => import('@/views/cpanel/push/New'),
      props: true,
      meta: {
        title: 'Редактирование push-уведомления',
        back: 'cpanel.push.list',
        middleware: Authenticated
      }
    }
  ]
},
{
  name: 'cpanel.light',
  path: 'light',
  component: () => import('@/layouts/index'),
  redirect: { name: 'cpanel.light.list' },
  meta: {
    title: 'Cкрининг light',
    back: 'cpanel.dashboard',
    middleware: Authenticated
  },
  children: [
    {
      name: 'cpanel.light.list',
      path: 'list',
      component: () => import('@/views/cpanel/light/List'),
      meta: {
        title: 'Cкрининг light',
        back: 'cpanel.dashboard',
        middleware: Authenticated
      }
    }
  ]
},
{
  name: 'cpanel.statistics',
  path: 'statistics',
  component: () => import('@/layouts/index'),
  // redirect: { name: 'cpanel.procedure.type' },
  meta: {
    title: 'Статистика',
    back: 'cpanel.dashboard',
    middleware: Authenticated
  },
  children: [
    {
      name: 'cpanel.statistics.users',
      path: 'users',
      component: () => import('@/views/cpanel/statistics/Users'),
      meta: {
        title: 'Статистика: Пользователи',
        back: 'cpanel.procedure',
        middleware: Authenticated
      }
    },
    {
      name: 'cpanel.statistics.light',
      path: 'light',
      component: () => import('@/views/cpanel/statistics/Light'),
      meta: {
        title: 'Статистика: light',
        back: 'cpanel.procedure',
        middleware: Authenticated
      }
    }
  ]
},
{
  name: 'cpanel.procedure',
  path: 'procedure',
  component: () => import('@/layouts/index'),
  redirect: { name: 'cpanel.procedure.type' },
  meta: {
    title: 'Процедуры',
    back: 'cpanel.dashboard',
    middleware: Authenticated
  },
  children: [
    {
      name: 'cpanel.procedure.type',
      path: 'type',
      component: () => import('@/views/cpanel/procedure/Types'),
      meta: {
        title: 'Типы процедуры',
        back: 'cpanel.procedure',
        middleware: Authenticated
      }
    },
    {
      name: 'cpanel.procedure.list',
      path: ':id?',
      component: () => import('@/views/cpanel/procedure/List'),
      meta: {
        title: 'Ограничения процедур',
        back: 'cpanel.procedure',
        middleware: Authenticated
      }
    }
  ]
},
{
  name: 'cpanel.logs',
  path: 'logs',
  component: () => import('@/layouts/index'),
  redirect: { name: 'cpanel.logs.list' },
  meta: {
    title: 'Логи',
    back: 'cpanel.dashboard',
    middleware: Authenticated
  },
  children: [
    {
      name: 'cpanel.logs.list',
      path: 'list',
      component: () => import('@/views/cpanel/logs/List'),
      meta: {
        title: 'Логи',
        back: 'cpanel.dashboard',
        middleware: Authenticated
      }
    }
  ]
}

]
